/**
 * Function to handle the form fields on the page
 * 
 * @config		context						the part of the DOM in which the handle should be initialized
 * @config		selectorFieldContainer		selector to get all elements that contain an input field on the DOM
 * @config		cssClassFilled				class attached when the field is filled in
 * @config		cssClassFocused				class attached when the field focused
 */
export default function FormFieldHandle ( config ) {
	if (!(this instanceof FormFieldHandle)) {
		return new FormFieldHandle(config);
	}
	let defaulConfig = {
		context: document,
		selectorFieldContainer: '.js-formFieldContainer',
		cssClassFilled: 'filled',
		cssClassFocused: 'focused'
	};
	this.config = Object.assign({}, defaulConfig, config);

	let allFieldContainers = Array.prototype.slice.call(this.config.context.querySelectorAll(this.config.selectorFieldContainer));
	allFieldContainers.some( container => {
		// added textarea because in this case it should have the same behaviour as inputs
		let input = container.querySelector('input') ? container.querySelector('input') : 
					container.querySelector('textarea') ? container.querySelector('textarea') : 
					container.querySelector('select') ? container.querySelector('select') : 
					undefined;
		
		if (input != undefined) {
			input.addEventListener('focus', e => { this.handleInput(input, container, e); });
			input.addEventListener('blur', e => { this.handleInput(input, container, e); });
			input.addEventListener('keyup', e => { this.handleInput(input, container, e); });
			input.addEventListener('change', e => { this.handleInput(input, container, e); });
		}
	});
}

/**
 * Function to handle all inputs
 * 
 * @param	input		HTML-Element	the input field where the event was triggered
 * @param	container	HTML-Element	the container of the input field
 * @param	event		Event			the event that was triggered
 */
FormFieldHandle.prototype.handleInput = function (input, container, event) {
	let value = input.value;

	if (event != undefined) {
		if (event.type == 'focus') {
			container.classList.add(this.config.cssClassFocused);
		} else if (event.type == 'blur') {
			container.classList.remove(this.config.cssClassFocused);
		}
	}

	if (value.length > 0) {
		container.classList.add(this.config.cssClassFilled);
	} else {
		container.classList.remove(this.config.cssClassFilled);
	}
}
